/**
 * Renderiza un componente para mostrar "No encontrado".
 *
 * @return {React.Component} Un componente React para mostrar "No encontrado".
 */
const NotFound = () => {
    return (
        <div>
            <h1>Not Found</h1>
        </div>
    )
}

export { NotFound }
